import type { JSX } from 'preact';
import { setPanel } from './panels.ts';
import './fps.css';

export const FPS_SYNC_MS = 250;

export type FpsProps = {
  fps: number;
};

export type FpsMeter = {
  sync: (state: FpsProps) => void;
  destroy: () => void;
};

export type FpsClock = {
  fps: number;
  at: number;
};

export function FpsPanel({ fps }: FpsProps): JSX.Element {
  return (
    <p class="fps-meter" aria-label={`${fps} frames per second`}>
      {fps}
    </p>
  );
}

export function createFpsClock(): FpsClock {
  return { fps: -1, at: 0 };
}

/** Skip identical integers and hold 250 ms so a flicker cannot re-render the overlay every frame. */
export function pushFps(
  handle: FpsMeter | null,
  loop: { actualFps: number; now: number },
  clock: FpsClock,
): void {
  const fps = Math.round(loop.actualFps);

  if (fps === clock.fps) {
    return;
  }

  if (clock.fps !== -1 && loop.now - clock.at < FPS_SYNC_MS) {
    return;
  }

  clock.fps = fps;
  clock.at = loop.now;
  handle?.sync({ fps });
}

export function mountFps(): FpsMeter {
  setPanel('fps', { fps: 0 });

  return {
    sync: (state) => setPanel('fps', state),
    destroy: () => setPanel('fps', null),
  };
}
